import React from "react";
import ModalMobile from "../../../components/shared/Modal/ModalMobile";
import { CreditSelectForm } from "./components/CreditSelectForm";
import { useState } from "react";
import { axiosWithToken, functionBaseUrl } from "../../../common/firebase";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { PurchaseResult } from "./components/PurchaseResult";

export const steps = {
  SELECT_PLAN: "SELECT_PLAN",
  PURCHASE_SUCCESS: "PURCHASE_SUCCESS",
  PURCHASE_FAILURE: "PURCHASE_FAILURE",
};

const ModalHandlePurchase = ({
  isOpen,
  onClose,
  handleRefetchCredits,
  handleUpgradeStudent,
  handleAutoRenewal,
  // user,
  student,
}) => {
  const [currentStep, setCurrentStep] = React.useState(steps.SELECT_PLAN);
  const [credits, setCredits] = useState(30);
  const [amount, setAmount] = useState(300);
  const [id, setId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState(false);
  const [unpaidCredit, setUnpaidCredit] = useState(0);
  const [custom, setCustom] = useState(false);

  const location = useLocation();

  const loadData = async () => {
    try {
      setIsLoading(true);
      const queryParams = new URLSearchParams(location.search);
      const userId = queryParams.get("userId");
      setId(userId);
      let userResponse = await axiosWithToken(
        `${functionBaseUrl}/api/users/${userId}`,
        {
          method: "GET",
        }
      );
      setUser(userResponse?.data);

      let response = await axiosWithToken(
        `${functionBaseUrl}/api/v1/unpaidCredits/coach/${userId}`,
        {
          method: "GET",
        }
      );
      if (response?.data?.credits?.length > 0) {
        setAmount(response?.data?.credits[0]?.amount);
        setCredits(response?.data?.credits[0]?.creditCount);
        setUnpaidCredit(response?.data?.credits[0]);
        setCustom(true);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      Swal.fire({
        title: '<p style="font-size:70%;">Error loading data</p>',
        icon: "error",
        confirmButtonText: "Ok",
        allowOutsideClick: true,
      });
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  function handlePackageChange(amount) {
    setAmount(0);

    if (amount === 300) {
      setCredits(30);
    } else if (amount === 500) {
      setCredits(60);
    } else if (amount === 700) {
      setCredits(100);
    } else if (amount === 1800) {
      setCredits(300);
    } else {
      setCredits(0);
    }

    setAmount(amount);
  }

  async function handleResult() {
    if (custom) {
      await axiosWithToken(`${functionBaseUrl}/api/v1/credits`, {
        method: "PATCH",
        data: { creditId: unpaidCredit?.id, info: { status: "complete" } },
      })
        .then(async () => {
          setCurrentStep(steps.PURCHASE_SUCCESS);
          await handleRefetchCredits();
        })
        .catch(async (error) => {
          setCurrentStep(steps.PURCHASE_FAILURE);
        });
    } else {
      let input = {
        amount: amount,
        creditCount: credits,
        status: "complete",
        userId: id,
        coachId: id,
        transactionType: "in",
        creditType: "studentCredits",
      };

      await axiosWithToken(`${functionBaseUrl}/api/v1/credits`, {
        method: "POST",
        data: input,
      })
        .then(async () => {
          setCurrentStep(steps.PURCHASE_SUCCESS);
          await handleRefetchCredits();
        })
        .catch(async (error) => {
          setCurrentStep(steps.PURCHASE_FAILURE);
        });
    }
  }

  const handleClose = () => {
    onClose();
    setCurrentStep(steps.SELECT_PLAN);
  };

  return (
    <ModalMobile
      isOpen={isOpen}
      onClose={handleClose}
      className="p-6 sm:max-w-[480px] lg:max-w-[1128px] "
    >
      <div style={{ maxHeight: "80vh" }}>
        {currentStep === steps.SELECT_PLAN && (
          <CreditSelectForm
            handlePackageChange={handlePackageChange}
            amount={amount}
            credits={credits}
            user={user}
            handleResult={handleResult}
            onClose={handleClose}
          />
        )}
        {currentStep === steps.PURCHASE_SUCCESS && (
          <PurchaseResult
            mainText="Purchase Successful"
            additionalText={`You have successfully purchased ${credits} credits, you can now use them to update your students subscriptions`}
            onClose={handleClose}
          />
        )}

        {currentStep === steps.PURCHASE_FAILURE && (
          <PurchaseResult
            mainText="Purchase Failed"
            additionalText={`Something went wrong. Please try again`}
            onClose={handleClose}
          />
        )}
      </div>
    </ModalMobile>
  );
};

export default ModalHandlePurchase;
